module.exports = __webpack_public_path__ + "img/Ident-Process-7-mobile.b5e33a46.png";